// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function use(refetch, variables, enabled, shouldContinue, intervalMs, immediateOpt) {
  let immediate = immediateOpt !== undefined ? immediateOpt : false;
  let match = React.useTransition();
  let startTransition = match[1];
  let match$1 = React.useState(() => false);
  let setHasFetched = match$1[1];
  let match$2 = React.useState(() => {});
  let setError = match$2[1];
  let match$3 = React.useState(() => 0);
  let setRestartVersion = match$3[1];
  let latest = React.useRef([
    refetch,
    shouldContinue
  ]);
  React.useEffect(() => {
    latest.current = [
      refetch,
      shouldContinue
    ];
  }, [
    refetch,
    shouldContinue
  ]);
  React.useEffect(() => {
    setHasFetched(param => false);
    setError(param => {});
    if (!enabled) {
      return;
    }
    let active = {
      contents: true
    };
    let timeout = {
      contents: undefined
    };
    let poll = first => {
      let match = latest.current;
      if (!(active.contents && (first || match[1]))) {
        return;
      }
      let refetch = match[0];
      startTransition(() => {
        refetch(variables, "network-only", error => {
          if (active.contents) {
            setHasFetched(param => true);
            setError(param => error);
            if (Stdlib_Option.isNone(error)) {
              timeout.contents = Primitive_option.some(setTimeout(() => poll(false), intervalMs));
              return;
            } else {
              return;
            }
          }
        });
      });
    };
    timeout.contents = Primitive_option.some(setTimeout(() => poll(true), immediate ? 0 : intervalMs));
    return () => {
      active.contents = false;
      Stdlib_Option.forEach(timeout.contents, prim => {
        clearTimeout(prim);
      });
    };
  }, [
    enabled,
    variables,
    intervalMs,
    match$3[0]
  ]);
  return {
    hasFetched: match$1[0] && !match[0],
    error: match$2[0],
    restart: () => {
      setHasFetched(param => false);
      setError(param => {});
      setRestartVersion(version => version + 1 | 0);
    }
  };
}

exports.use = use;
/* react Not a pure module */
